export class PractitionerDeleteLocation {
  PractitionerId: number;
  healthSystemIds:number []
}
